function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "color", "variant", "size", "children", "style", "disabled", "type", "showTooltip", "tooltipContent", "width"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { cn, opacityColorByPercent } from "../../../lib/utils";
import Wave from "../../../lib/wave";
import { cva } from 'class-variance-authority';
import { injectIconButtonStyles } from "./style";
injectIconButtonStyles();
import React, { forwardRef, lazy, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Tooltip = /*#__PURE__*/lazy(function () {
  return import("../tooltip");
});
var IconButtonTypesMap = {
  DEFAULT: 'default',
  OUTLINED: 'outlined',
  FLOAT: 'float'
};
var iconButtonVariants = cva(['inline-flex items-center justify-center', 'transition-all rounded-lg select-none cursor-pointer', 'data-[disabled]:text-[var(--bds-gray-t4-dis)] data-[disabled]:cursor-not-allowed data-[disabled]:bg-transparent data-[disabled]:pointer-events-none', 'focus-visible:outline-none'], {
  variants: {
    variant: {
      default: ['text-[var(--bds-gray-t2)]', 'hover:bg-base-bds-trans-hover', 'active:active:text-[var(--bds-gray-t1-title)] active:active:bg-base-bds-trans-hover', 'focus-visible:outline-none ring-btn-default focus-visible:ring-[5px]'],
      outlined: ['text-[var(--bds-gray-t1-title)]', 'border border-solid border-base-bds-gray-t4-dis', 'hover:text-[var(--bds-gray-t2)]', 'active:text-[var(--bds-gray-t1-title)]', 'focus-visible:outline-none ring-btn-default focus-visible:ring-[5px]'],
      float: ['text-[var(--bds-gray-t1-title)]', 'hover:text-[var(--bds-gray-t2)]', 'active:text-[var(--bds-gray-t1-title)]']
    },
    size: {
      'xx-small': 'rounded',
      'x-small': 'rounded',
      small: 'rounded',
      middle: '',
      large: '',
      'x-large': ''
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'middle'
  }
});
var IconButton = /*#__PURE__*/forwardRef(function IconButton(props, ref) {
  var className = props.className,
    color = props.color,
    variant = props.variant,
    size = props.size,
    children = props.children,
    style = props.style,
    disabled = props.disabled,
    type = props.type,
    _props$showTooltip = props.showTooltip,
    showTooltip = _props$showTooltip === void 0 ? false : _props$showTooltip,
    tooltipContent = props.tooltipContent,
    width = props.width,
    others = _objectWithoutProperties(props, _excluded);
  var _colorStyle = useMemo(function () {
    if (!color) return {};
    if (width) {
      return {
        backgroundColor: opacityColorByPercent(color, 0.2),
        width: width,
        height: width
      };
    } else {
      return {
        backgroundColor: opacityColorByPercent(color, 0.2)
      };
    }
  }, []);
  var _widthStyle = useMemo(function () {
    if (!width) return {};
    return {
      width: width,
      height: width
    };
  }, []);
  var tabIndex = 'outlined' === variant || 'default' === variant ? 0 : -1;
  var renderComponent = null;
  var iconbutton = /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: cn('moly-iconbutton', "".concat(type ? "type-".concat(type) : ''), "".concat(variant || 'default', " "), "".concat(size || 'middle'), iconButtonVariants({
      variant: variant,
      size: size
    }), className),
    ref: ref,
    "data-disabled": disabled ? '' : undefined,
    tabIndex: tabIndex,
    style: _objectSpread(_objectSpread(_objectSpread({}, style), _colorStyle), _widthStyle)
  }, others), {}, {
    children: children
  }));
  var outlinedIconbutton = /*#__PURE__*/_jsx(Wave, {
    component: "IconButton",
    children: iconbutton
  });
  if (IconButtonTypesMap.OUTLINED === variant) {
    renderComponent = outlinedIconbutton;
  } else {
    renderComponent = iconbutton;
  }
  return showTooltip && tooltipContent ? /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipContent,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: renderComponent
    })
  }) : renderComponent;
});
IconButton.displayName = 'IconButton';
export { IconButton, iconButtonVariants };